module.exports = __webpack_public_path__ + "static/media/europianroullete.bf319348.webp";